var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ContextMenuAFY, icons, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { SpanStatus } from "./style";
export var dataFormBranch = {
    id: "",
    Name: "",
    Code: "",
};
export var Columns = function (handleClickContextMenu) {
    return [
        {
            field: "actions",
            headerName: "Acciones",
            width: 80,
            renderCell: function (params) {
                return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(ContextMenuAFY, { colorButton: "#fff", iconButton: icons.MoreVert, iconColor: "#3A56A1", menuItem: [
                            {
                                disabled: false,
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.Edit,
                                    size: sizesIcon.standard,
                                },
                                id: "1",
                                name: "Modificar",
                            },
                            {
                                icon: {
                                    color: "#006ac6",
                                    icon: icons.Delete,
                                    size: sizesIcon.standard,
                                },
                                disabled: false,
                                id: "2",
                                name: "Eliminar",
                            },
                        ], onClickContextMenu: function (item) {
                            return handleClickContextMenu(item, params);
                        }, sizeIcon: sizesIcon.standard }) })));
            },
        },
        {
            editable: false,
            field: "Enable",
            headerName: "Estado",
            width: 100,
            renderCell: function (params) {
                return (_jsxs("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: [_jsx(SpanStatus, { style: {
                                backgroundColor: params.row.Enable === "true" ? "#46c51a" : "#46c51a",
                            } }), params.row.Enable === "true" ? "Activo" : "Activo"] })));
            },
        },
        {
            field: "Code",
            headerName: "Codigo",
            width: 180,
        },
        {
            field: "Name",
            headerName: "Nombre",
            width: 300,
        },
    ];
};
